import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog.jsx'
import { Icon } from '@iconify/react'
import { TypographyP, TypographySmallMuted } from '@/components/ui/typography.jsx'

export const NewReportDialog = ({ isDialogOpen, setIsDialogOpen, onCreateNewReport }) => {
    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogContent className="">

                <DialogDescription />
                <DialogHeader>
                    <DialogTitle>Create A New Report</DialogTitle>
                </DialogHeader>
                <div className="flex flex-col">

                    <div className="flex items-center gap-4 transition cursor-pointer hover:bg-accent p-4 rounded" onClick={() => onCreateNewReport('super-segments')}>
                        <Icon icon="bitcoin-icons:lightning-outline" className="h-10 w-10 flex-shrink-0 border p-2 rounded-full bg-gradient-to-r from-primary to-secondary text-primary-foreground" />
                        <div>
                            <TypographyP>
                                Super Segments
                            </TypographyP>
                            <TypographySmallMuted>
                                Group creatives by super segments - defined by your own words
                            </TypographySmallMuted>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 transition cursor-pointer hover:bg-accent p-4 rounded" onClick={() => onCreateNewReport('top-performing')}>
                        <Icon icon="iconoir:medal" className="h-10 w-10 flex-shrink-0 border p-2 rounded-full text-primary border-primary" />
                        <div>
                            <TypographyP>Top Performing</TypographyP>
                            <TypographySmallMuted>
                                See which creatives are achieving the best performance
                            </TypographySmallMuted>
                        </div>
                    </div>

                    <div className="flex items-center gap-4 transition cursor-pointer hover:bg-accent p-4 rounded" onClick={() => onCreateNewReport('custom-groups-comparison')}>
                        <Icon icon="clarity:node-group-line" className="h-10 w-10 flex-shrink-0 border p-2 rounded-full text-secondary border-secondary" />
                        <div>
                            <TypographyP>Custom Groups Comparison</TypographyP>
                            <TypographySmallMuted>
                                Evaluate multiple sets of creatives against each other by filtering through custom groups
                            </TypographySmallMuted>
                        </div>
                    </div>


                </div>
            </DialogContent>
        </Dialog>
    )
}